import { ErrorBag, FieldBag } from 'vee-validate';

export default {
    methods: {
        processLaravelErrors(
            $validator,
            response,
            use_scope = false,
            field_pos = 'last',
        ) {
            const errors = $validator.errors;

            if (errors !== undefined) {
                $validator.errors.clear();
            }

            if (response.status === 422) {
                const laravelErrors = response.data;
                const errorBag = new ErrorBag(null, $validator.id);

                Object.keys(laravelErrors).forEach((k, i) => {
                    Array.from(laravelErrors[k]).forEach(v => {
                        if (use_scope) {
                            const error = {
                                field: this.getErrorField(k, field_pos),
                                msg: this.translateErrorMessage(
                                    v,
                                    k,
                                    field_pos,
                                ),
                                scope: k,
                            };

                            errorBag.add(error);
                        } else {
                            errorBag.add({
                                field: this.getErrorField(k, field_pos),
                                msg: this.translateErrorMessage(
                                    v,
                                    k,
                                    field_pos,
                                ),
                            });
                        }
                    });
                });

                $validator.errors = errorBag;
            }
        },

        hasLaravelErrors(error) {
            if (_.isNil(error.response)) return false;
            if (error.response.status === 422) return true;

            return false;
        },

        getErrorField(field, pos) {
            return _[pos](field.split('.'));
        },

        translateErrorMessage(msg, field, pos) {
            return msg.replace(field, this.getErrorField(field, pos));
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/validator-laravel-error.js